import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import general from '../../../modulos/general';

// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, handleClickidLista, idListaP}) => {
  // console.log(elemento.idPlanta, idListaP.idPlanta)
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
    {/* <tr className=''> */}
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrPlanta}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrSeccion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrEquipo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrComponente}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrMecanismo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrAplicacion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrMetodo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrTarea}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrLubricante}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.tipoLub}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.claseLub}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.categoriaLub}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.descrGrado}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.tipoGrado}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.apiSAE}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>{elemento.isoGrasa}</td>

      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#faf5aa'}}>
        {elemento.archRotulo &&
          <img src={elemento.archRotulo} height='50' width='100' alt="Rotulo" />
        }
        {!elemento.archRotulo &&
          "" 
        }
      </td>

    </tr>
  )
};

const ListaPl = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos

class ConfGenRot2 extends React.Component {
  state={listRot: this.props.list, idListaP: [], verRotulo: false,
    argsAdd: {}, errorAdd: [], procBtn: 0, permiteBtn1: true, confirmaAct: false, open: false
    }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()

// console.log(idListaP)
    this.setState({idListaP: idListaP})
  
  }

  handlePDF = async (ev, list, args)=>{
    // console.log(list)
    this.setState({verRotulo: true})

    let argsBuscar = {}, argsBuscar1 = {}
    argsBuscar = `'descrEmpresa': '${list[0].descrEmpresa}'`
    argsBuscar1 = `'descrEmpresa': '${list[0].descrEmpresa}'`

    if(args.descrPlanta){
      argsBuscar1 += `, 'descrPlanta': /${args.descrPlanta}/i`
    }
    if(args.descrSeccion){
      argsBuscar1 += `, 'descrSeccion': /${args.descrSeccion}/i`
    }
    if(args.descrEquipo){
      argsBuscar1 += `, 'descrEquipo': /${args.descrEquipo}/i`
    }
    if(args.descrComponente){
      argsBuscar1 += `, 'descrComponente': /${args.descrComponente}/i`
    } 

    let argsBuscarPl = {}
    let argsQuery = `{"$unwind": "$secciones"}, 
    {"$unwind": "$secciones.equipos"}, 
    {"$unwind": "$secciones.equipos.componentes"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"}, 
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: '$secciones.descrSeccion',
      descrEquipo: '$secciones.equipos.descrEquipo',
      descrComponente: '$secciones.equipos.componentes.descrComponente',
      descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
      archRotulo: '$secciones.equipos.componentes.mecanismos.programacion.archRotulo'}},
    {$match: {${argsBuscar1}}}, 
    {$lookup: {from: 'rotulos', localField: 'archRotulo', foreignField: 'descrRotulo', as: 'rotulo'}},
    {$unwind: '$rotulo'},
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, 
      descrMecanismo: 1, archRotulo: '$rotulo.archRotulo'}},
    {$group: {_id: {_id: '$_id', descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta', 
      descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', descrComponente: '$descrComponente', 
      descrMecanismo: '$descrMecanismo', archRotulo: '$archRotulo'}}},
    {$group: {_id: {_id: '$_id._id', descrEmpresa: '$_id.descrEmpresa', archRotulo: '$_id.archRotulo'}, count: { $sum: 1 }}},
    {$project: {_id: '$_id._id', archRotulo: '$_id.archRotulo', numCarta: {$toInt: '$count'}}}`
    argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${argsQuery}]`}
console.log(argsBuscarPl)
    let regExiste = []

    if(this.props.allPlantaRtesPDF.allPlantaRtes){
      let {data} = await this.props.allPlantaRtesPDF.refetch(argsBuscarPl)
      regExiste = await data.allPlantaRtes

      if(regExiste.length>0){
        document.body.style.cursor = 'wait'

        let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
        let widthDoc = 210
        let heightDoc = (doc.internal.pageSize.height)

        doc.setFontSize(10);
        doc.setFontStyle('bold');
        let posic = 45

        let numOrden = 0 
        let totalRot = 0
        posic=75
        for(let iii=0; iii<regExiste.length; iii++){
          numOrden = iii+1
          totalRot+=regExiste[iii].numCarta
          doc.text(general.formatNum(numOrden.toString()), 20, posic) 
          let imgSourceCB = new Image();
          imgSourceCB.src = regExiste[iii].archRotulo;
          doc.convertStringToImageData(imgSourceCB)
          doc.addImage(imgSourceCB, 'PNG', 27, posic-20, 106, 53);
          doc.text("-------------------------------------------------------------", 80, posic) 
          doc.text(general.formatNum(regExiste[iii].numCarta.toString()), 160, posic)
          posic+=50
          if(posic>heightDoc-30 && iii<regExiste.length-1){
            posic=75
            doc.addPage()
          }
          if(iii===regExiste.length-1){
            doc.text("TOTAL DE ROTULOS: " + general.formatNum(totalRot.toString()), 20, posic-20) 

          }
        }
        const pageCount = doc.internal.getNumberOfPages();
        for(var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
  
  //ENCABEZADO DE PAGINA
  
          let dirSlcm = 'images/logos/LCMSAS.png'
          let imgSource = new Image();
          try{
            imgSource.src = dirSlcm;
            doc.convertStringToImageData(imgSource)
            doc.addImage(imgSource, 'PNG', 20, 12, 55, 17);
          }catch{
            console.log("Logo de LCM no existe")
          }
          doc.text("CANTIDAD DE ROTULOS REQUERIDOS EN " + list[0].descrEmpresa, widthDoc/2.5, 35, 'center')
          doc.text("#                      Rotulo                                                                                                   Cantidad", 20, 50) 
        }
        let nameDoc = `CANTIDAD DE ROTULOS.pdf`

        
        this.setState({verRotulo: false})
        document.body.style.cursor = 'default'
        this.setState({permiteBtn1: true, open: false, confirmaAct: false})
        doc.save(nameDoc)
      }
    }
  }



  handleSubmit = async (ev, list, listaRotulos)=>{
    this.setState({verRotulo: true})
    document.body.style.cursor = 'wait'

    let addColeccPl = []

    for(let ii=0; ii<list.length; ii++){
      let descrRotulo = list[ii].descrFrecuencia + '_' + list[ii].claseLub + '_' + list[ii].colorAplicacion + '_' + list[ii].categoriaLub + '_' + list[ii].colorGrado + '_' + list[ii].tipoGrado + '_' + list[ii].colorTexto
      if(list[ii].isoGrasaColor){
        descrRotulo += '_' + list[ii].isoGrasaColor
      }
      if(list[ii].isoGrasaTexto){
        descrRotulo += '_' + list[ii].isoGrasaTexto
      }
      if(list[ii].apiSAE){
        descrRotulo += '_' + list[ii].apiSAE
      }

      let argsPl = {}, argsProg = {}
      let addColeccProg = []

      argsProg['archRotulo'] = descrRotulo
      argsProg['descrMetodo'] = list[ii].descrMetodo
      argsProg['descrTarea'] = list[ii].descrTarea
      addColeccProg.push(argsProg)
      argsProg = {}

      argsPl['descrEmpresa'] = list[ii].descrEmpresa
      argsPl['descrPlanta'] = list[ii].descrPlanta
      argsPl['descrSeccion'] = list[ii].descrSeccion
      argsPl['descrEquipo'] = list[ii].descrEquipo
      argsPl['descrComponente'] = list[ii].descrComponente
      argsPl['descrMecanismo'] = list[ii].descrMecanismo
      argsPl['programacion'] = addColeccProg
      argsPl['tipoAct'] = "EditarProgRotulo"
      addColeccPl.push(argsPl)
      argsPl = {}
      addColeccProg = []
    }  
    let updColeccProg = [], updColeccProg1 = []

    for(let iii=0; iii<addColeccPl.length; iii++){
        updColeccProg.push(addColeccPl[iii])
    }

    updColeccProg1.push({planta: updColeccProg})

    let numDocCRUD = 0
    let totDocCRUD = 1
    let argsCrud = []
    let crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editPlantaEstructura)
    }

    argsCrud[numDocCRUD] = updColeccProg1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editPlantaEstructura

    await this.updColecc(crudColecc, argsCrud, totDocCRUD)
   
    let listRot = await this.state.listRot
    let rotGen = 0
    let totalRot = 0
    let totalNoRot = 0
    let cantRot = [], cantRot1 = []

    const argsDel = {_id: 1}
    await this.props.deleteRotulo({
      variables: argsDel
    });
    let response = await this.props.fecha({
      variables: {}
    }); 
    document.body.style.cursor = 'default'

    const {fechaHoraHoy} = response.data.fecha
console.log(listaRotulos.length)
    for(let ii=0; ii<listaRotulos.length; ii++){
console.log(ii)
      let crearRotulo = true
      let figExterna = '', colorBorde = '', colorFigExterna = '', figInterna = '', colorFigInterna = ''
      let isoGrasaColor = '', isoGrasaTexto = ''

      if(listaRotulos[ii].descrFrecuencia){
        switch (listaRotulos[ii].descrFrecuencia) {
          case 'Cada 8 horas':
            figExterna = '1'
            break;
          case '100 Km':
            figExterna = '1'
            break;
          case 'Cada turno':
            figExterna = '1'
            break;
          case 'Diario':
            figExterna = '2'
            break;
          case '24 horas':
            figExterna = '2'
            break;
          case '250 Km':
            figExterna = '2'
            break;
          case 'Cada 2 días':
            figExterna = '3'
            break;
          case '48 horas':
            figExterna = '3'
            break;
          case '100 horas':
            figExterna = '3'
            break;
          case '500 Km':
            figExterna = '3'
            break;
          case 'Semanal':
            figExterna = '4'
            break;
          case '150 horas':
            figExterna = '4'
            break;
          case '200 horas':
            figExterna = '4'
            break;
          case '1000 Km':
            figExterna = '4'
            break;
          case 'Quincenal':
            figExterna = '5'
            break;
          case '250 horas':
            figExterna = '5'
            break;
          case '300 horas':
            figExterna = '5'
            break;
          case '350 horas':
            figExterna = '5'
            break;          
          case '2000 Km':
            figExterna = '5'
            break;
          case 'Mensual':
            figExterna = '6'
            break;
          case '500 horas':
            figExterna = '6'
            break;
          case '480 horas':
            figExterna = '6'
            break;          
          case '5000 Km':
            figExterna = '6'
            break;          
          case '7000 Km':
            figExterna = '6'
            break;
          case 'Bimestral':
            figExterna = '7'
            break;
          case '1000 horas':
            figExterna = '7'
            break;
          case '1500 horas':
            figExterna = '7'
            break;
          case '10000 Km':
            figExterna = '7'
            break;
          case '15000 Km':
            figExterna = '7'
            break;
          case 'Trimestral':
            figExterna = '8'
            break;
          case '2000 horas':
            figExterna = '8'
            break;
          case '20000 Km':
            figExterna = '8'
            break;
          case 'Cuatrimestral':
            figExterna = '9'
            break;
          case '3000 horas':
            figExterna = '9'
            break;
          case '30000 Km':
            figExterna = '9'
            break;  
          case '40000 Km':
            figExterna = '9'
            break;
          case 'Semestral':
            figExterna = '10'
            break;
          case '4000 horas':
            figExterna = '10'
            break;
          case '50000 Km':
            figExterna = '10'
            break;
          case '60000 Km':
            figExterna = '10'
            break;
          case 'Anual':
            figExterna = '11'
            break;
          case '8000 horas':
            figExterna = '11'
            break;
          case '90000 Km':
            figExterna = '11'
            break;
          case '100000 Km':
            figExterna = '11'
            break;
          case 'Cada 2 años':
            figExterna = '12'
            break;
          case '12000 horas':
            figExterna = '12'
            break;  
          case '16000 horas':
            figExterna = '12'
            break;
          case '20000 horas':
            figExterna = '12'
            break;          
          case '120000 Km':
            figExterna = '12'
            break;
          case '150000 Km':
            figExterna = '12'
            break;
          case '200000 Km':
            figExterna = '12'
            break;
          case 'Cada 3 años':
            figExterna = '13'
            break;
          case '30000 horas':
            figExterna = '13'
            break;
          case '32000 horas':
            figExterna = '13'
            break;          
          case '300000 Km':
            figExterna = '13'
            break;
          case 'Cada 5 años':
            figExterna = '15'
            break;
          case '40000 horas':
            figExterna = '15'
            break;
          case '500000 Km':
            figExterna = '15'
            break;
          case 'Predictiva':
            figExterna = '14'
            break;
          default:
            console.log(listaRotulos[ii].descrFrecuencia)
            crearRotulo = false
            break;
        }
      }else{
        console.log("Sin frecuencia")
        crearRotulo = false
      }
      // console.log(ii)
      if(listaRotulos[ii].claseLub){
        switch (listaRotulos[ii].claseLub) {
          case 'Mineral':
            colorBorde = 'yellow'
            break;
          case 'Sintético':
            colorBorde = 'blue'
            break;
          case 'Vegetal':
            colorBorde = 'green'
            break;
          default:
            console.log(listaRotulos[ii].claseLub)
            crearRotulo = false
            break;
        }
      }else{
        console.log("Sin clase lub")
        crearRotulo = false
      }
      // console.log(ii)

      if(listaRotulos[ii].colorAplicacion){
        colorFigExterna = listaRotulos[ii].colorAplicacion
      }else{
        console.log("Sin color aplicación")
        crearRotulo = false
      }
      // console.log(ii)

      if(listaRotulos[ii].categoriaLub){
        switch (listaRotulos[ii].categoriaLub) {
          case 'H1':
            figInterna = '1'
            break;
          case 'H2':
            figInterna = '2'
            break;
          case 'H3':
            figInterna = '3'
            break;
          case '3H':
            figInterna = '4'
            break;
          default:
            console.log(listaRotulos[ii].categoriaLub)
            crearRotulo = false
            break;
        }
      }else{
        crearRotulo = false
      }
      // console.log(ii)
      if(listaRotulos[ii].colorGrado){
        colorFigInterna = listaRotulos[ii].colorGrado

        if(listaRotulos[ii].tipoGrado==="NLGI"){
          if(listaRotulos[ii].isoGrasaColor){
            isoGrasaColor = listaRotulos[ii].isoGrasaColor
          }else{
            crearRotulo = false
          }
          if(listaRotulos[ii].isoGrasaTexto){
            isoGrasaTexto = listaRotulos[ii].isoGrasaTexto
          }else{
            crearRotulo = false
          }
        }
      }else{
        crearRotulo = false
      }
      //Color del texto
      let colorTexto = ""
      if(listaRotulos[ii].colorTexto&&(listaRotulos[ii].colorTexto==="BLANCO"||listaRotulos[ii].colorTexto==="NEGRO")){
        if(listaRotulos[ii].colorTexto==="BLANCO"){
          colorTexto = "#FFFFFF"
        }
        if(listaRotulos[ii].colorTexto==="NEGRO"){
          colorTexto = "#000000"
        }
      }else{
        crearRotulo = false
      }
      //Color del texto ISO
      if(listaRotulos[ii].isoGrasaTexto&&(listaRotulos[ii].isoGrasaTexto==="BLANCO"||listaRotulos[ii].isoGrasaTexto==="NEGRO")){
        if(listaRotulos[ii].isoGrasaTexto==="BLANCO"){
          isoGrasaTexto = "#FFFFFF"
        }
        if(listaRotulos[ii].isoGrasaTexto==="NEGRO"){
          isoGrasaTexto = "#000000"
        }
      }

      let svgrotulo = document.getElementById('svgrotulo')

        if(crearRotulo){
          document.body.style.cursor = 'wait'

          totalRot += 1
          rotGen += 1
          const SVG_NS = "http://www.w3.org/2000/svg"
          while (svgrotulo.firstChild) {
            svgrotulo.removeChild(svgrotulo.firstChild);
          }
          
          let objeto = {}
          let sumarPosXFI1 = 0, sumarPosXFI2 = 0, sumarPosXFI3 = 0, sumarPosXFI4 = 0
          let sumarPosYFI1 = 0, sumarPosYFI2 = 0, sumarPosYFI3 = 0, sumarPosYFI4 = 0
          let sumarRadioFI2 = 0, sumarTamFI3y4 = 0
          let sumarPosYNLGI = 0, sumarPosXNLGI = 0, sumarWidthNLGI = 0

          sumarPosXFI1 = 2
          sumarPosYFI1 = 9
          sumarPosYFI2 = 6
          sumarPosYFI3 = 6
          sumarPosYFI4 = 12
          sumarPosXNLGI = 2
          sumarPosYNLGI = 8
          sumarWidthNLGI = sumarPosYFI1

          switch (figExterna) {
            case '1':
              objeto = {cx: 100, cy: 50, rx: 70, ry: 40, fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "ellipse", svgrotulo);
              // objeto = {cx: 100, cy: 50, rx: 64, ry: 34, fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "ellipse", svgrotulo);
              
              objeto = {points: '30,50 30,150 170,150 170,50', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '36,50 36,144 164,144 164,50', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '2':
              objeto = {cx: 100, cy: 110, rx: 70, ry: 40, fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "ellipse", svgrotulo);
              // objeto = {cx: 100, cy: 110, rx: 64, ry: 34, fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "ellipse", svgrotulo);
              
              objeto = {points: '30,110 30,50 100,10 170,50 170,110', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '36,110 36,50 100,16 164,50 164,110', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '3':
              objeto = {points: '62,7 30,150 170,150 140,10 58,10', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '66,16 36,144 164,144 134,16 66,16', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '4':
              objeto = {x: '30', y: '30', width: '140', height: '105', rx: '40', ry: '40', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "rect", svgrotulo);
              // objeto = {x: '36', y: '36', width: '128', height: '88', rx: '40', ry: '40', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "rect", svgrotulo);

              break;
            case '5':
              objeto = {points: '22,82 100,5 180,82 100,160 18,80', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '26,80 100,6 174,80 100,154 26,80', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '6':
              objeto = {x: '30', y: '10', width: '140', height: '140', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "rect", svgrotulo);
              // objeto = {x: '36', y: '16', width: '128', height: '128', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "rect", svgrotulo);

              break;
            case '7':
              objeto = {points: '30,145 30,75 100,5 170,75 170,145 26,145', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '36,144 36,80 100,16 164,80 164,144 36,144', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '8':
              sumarPosXFI1 = 5
              sumarPosYFI1 = 9 + 18
              sumarPosYFI2 = 10 + 18
              sumarPosYFI3 = 16 + 18
              sumarTamFI3y4 = 10
              sumarPosYFI4 = 20 + 18
              sumarRadioFI2 = 5
              sumarPosXNLGI = 5
              sumarPosYNLGI = 8 + 18
              sumarWidthNLGI = 11
      
              objeto = {points: '20,150 100,6 180,150 20,150 100,6', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '30,144 100,10 170,144 30,144', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;

            case '9':
              objeto = {points: '60,150 30,60 100,10 170,60 140,150 57,150', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '36,144 36,80 100,16 164,80 164,144 36,144', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;

            case '10':
              objeto = {points: '30,81 70,10 130,10 170,80 130,150 70,150 30,79', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '36,80 70,16 130,16 164,80 130,144 70,144 36,80', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '11':
              objeto = {points: '30,10 130,10 170,70 170,150 30,150 30,10 130,10', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '36,16 130,16 164,70 164,144 36,144 36,16', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '12':
              objeto = {points: '24,10 108,10 170,70 170,150 90,150 28,90 28,10', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '34,16 108,16 164,70 164,144 90,144 34,90 34,16', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '13':
              objeto = {points: '57,10 170,10 140,150 30,150 60,7', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polyline", svgrotulo);
              // objeto = {points: '66,16 164,16 136,144 36,144 66,16', fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "polyline", svgrotulo);

              break;
            case '14':
              objeto = {cx: 100, cy: 80, r: 70, fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "circle", svgrotulo);
              // objeto = {cx: 100, cy: 80, r: 64, fill: colorFigExterna};
              // dibujarElementoSVG(objeto, "circle", svgrotulo);

              break;
            case '15':
                objeto = {points: '28,135 28,35 168,15 168,135', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
                dibujarElementoSVG(objeto, "polygon", svgrotulo);
              break;
            default:
              break;
          }

          let tamFuente = 10
          if(listaRotulos[ii].tipoGrado!=="NLGI"){
            sumarPosYFI1 -= 6
            sumarPosYFI2 -= 12
            sumarPosYFI3 -= 12
            sumarPosYFI4 -= 6
          }
          let colorBordeInterno=""
          if(colorFigExterna===colorFigInterna){
            if(colorFigExterna==="#000000"){
              colorBordeInterno="#D3D3D3"
            }else{
              colorBordeInterno="#000000"
            }
          }else{
            colorBordeInterno=colorFigInterna
          }
          if(figInterna==='1'){
            objeto = {x: 65+sumarPosXFI1, y: 45+sumarPosYFI1/2+(sumarPosYFI1), width: 70-(sumarWidthNLGI),
                      height: 70-(sumarWidthNLGI), fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
            dibujarElementoSVG(objeto, "rect", svgrotulo);
          }
          if(figInterna==='2'){
            objeto = {cx: 100, cy: 86+sumarPosYFI2, r: 35 - sumarRadioFI2, fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
            dibujarElementoSVG(objeto, "circle", svgrotulo);
          }
          if(figInterna==='3'){
            let posY1 = 120+sumarPosYFI3 - sumarTamFI3y4
            let posY2 = 50+sumarPosYFI3
            objeto = {points: `65,${posY1} 100,${posY2} 135,${posY1} 65,${posY1}`, fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
          }
          if(figInterna==='4'){
            objeto = {points: `${65+(sumarTamFI3y4/2)},${80+sumarPosYFI4 - (sumarTamFI3y4/2)} 100,${45+sumarPosYFI4} ${135-(sumarTamFI3y4/2)},${80+sumarPosYFI4 - (sumarTamFI3y4/2)} 100,${115+sumarPosYFI4 - sumarTamFI3y4} ${65+(sumarTamFI3y4/2)},${80+sumarPosYFI4 - (sumarTamFI3y4/2)}`, fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
          }

          let ptoX = '100'
          let ptoYL1 = '77', ptoYL2 = '92', ptoYL3 = '107'
          if(listaRotulos[ii].apiSAE.length>9){
            tamFuente = 9
          }

          if(figExterna==='8'){
            ptoYL1 = '103'
            ptoYL2 = '117'
            ptoYL3 = '131'
            if(figInterna==='2'&&listaRotulos[ii].apiSAE.length>9){
              ptoYL1 = '103'
              ptoYL2 = '113'
              ptoYL3 = '123'
            }
          }
          if(figInterna==='3'&&figExterna!=='8'){
            ptoYL1 = '100'
            ptoYL2 = '113'
            ptoYL3 = '123'
          }
          if(figInterna==='3'&&figExterna==='8'){
            ptoYL1 = '122'
            ptoYL2 = '132'
            ptoYL3 = '142'
          }
          if(figInterna==='4'&&figExterna!=='8'){
            ptoYL1 = '85'
            ptoYL2 = '98'
            ptoYL3 = '108'
          }
          if(figInterna==='4'&&figExterna==='8'){
            ptoYL1 = '110'
            ptoYL2 = '120'
            ptoYL3 = '130'
          }
          if(figInterna==='4'&&figExterna!=='8'&&listaRotulos[ii].apiSAE.length>6){
            ptoYL1 = '85'
            ptoYL2 = '95'
            ptoYL3 = '104'
            if(listaRotulos[ii].apiSAE.length>9){
              tamFuente = 8
              ptoYL1 = '83'
              ptoYL2 = '93'
              ptoYL3 = '101'
            }
          }
          if(figInterna==='4'&&figExterna==='8'&&listaRotulos[ii].apiSAE.length>6){
            ptoYL1 = '106'
            ptoYL2 = '116'
            ptoYL3 = '124'
            if(listaRotulos[ii].apiSAE.length>9){
              tamFuente = 8
              ptoYL1 = '102'
              ptoYL2 = '112'
              ptoYL3 = '119'
            }
          }
          if(listaRotulos[ii].tipoGrado!=="NLGI"){
            ptoYL1 -= 6
            ptoYL2 -= 6
            ptoYL3 -= 6
            if(figInterna==='3'){
              ptoYL1 -= 12
              ptoYL2 -= 12
              ptoYL3 -= 12
            }
          }
// if(listaRotulos[ii].isoGrasaTexto==='BLANCO'){
//   console.log(listaRotulos[ii].descrGrado, listaRotulos[ii].tipoGrado, isoGrasaColor, isoGrasaTexto)
// }
          if(listaRotulos[ii].descrGrado){
            console.log(listaRotulos[ii].descrGrado, listaRotulos[ii].tipoGrado, colorTexto)

            let tamFuente1 = 15
            objeto = {x: '100', y: ptoYL1, fill: colorTexto, 'font-family': 'Calibri', 'font-size': tamFuente1, 
              'font-weight': 'Bold', 'text-anchor': 'middle'};
            dibujarElementoSVG(objeto, "text", svgrotulo, listaRotulos[ii].descrGrado);
          } 
          if(listaRotulos[ii].tipoGrado){
            let tamFuente1 = 15
            objeto = {x: ptoX, y: ptoYL2, fill: colorTexto, 'font-family': 'Calibri', 'font-size': tamFuente1, 
              'font-weight': 'Bold', 'text-anchor': 'middle'};
            dibujarElementoSVG(objeto, "text", svgrotulo, listaRotulos[ii].tipoGrado);
            if(listaRotulos[ii].tipoGrado==="SAE"){
              objeto = {x: ptoX, y: ptoYL3, fill: colorTexto, 'font-family': 'Calibri', 'font-size': tamFuente, 
                        'font-weight': 'Bold', 'text-anchor': 'middle'};
              dibujarElementoSVG(objeto, "text", svgrotulo, listaRotulos[ii].apiSAE);
            }
            if(listaRotulos[ii].tipoGrado==="NLGI"){
              objeto = {x: 65+sumarPosXNLGI, y: 33+(sumarPosYNLGI/2)+(sumarPosYNLGI), width: 70-(sumarWidthNLGI),
                height: 14, fill: isoGrasaColor};
              dibujarElementoSVG(objeto, "rect", svgrotulo);
            
              objeto = {x: ptoX, y: 44+(sumarPosYNLGI/2)+(sumarPosYNLGI), fill: isoGrasaTexto, 'font-family': 'Calibri',
                'font-size': 12, 'font-weight': 'Bold', 'text-anchor': 'middle'};
              dibujarElementoSVG(objeto, "text", svgrotulo, "ISO " + listaRotulos[ii].isoGrasa);
            }
          }

          function dibujarElementoSVG(objeto, nombreElemento, elementoPadre, texto) {
            // console.log(objeto, nombreElemento, elementoPadre, texto)
            let elemento = document.createElementNS(SVG_NS, nombreElemento);
            for (var nombre in objeto) {
              if (objeto.hasOwnProperty(nombre)) {
                elemento.setAttributeNS(null, nombre, objeto[nombre]);
              }
            }
            if(nombreElemento==="text"){
              let txt = document.createTextNode(texto);
              elemento.appendChild(txt);
            }
            elementoPadre.appendChild(elemento);
          }

          const updState = async (data, ii, svgrotulo) => {

            let descrRotulo = listaRotulos[ii].descrFrecuencia + '_' + listaRotulos[ii].claseLub + '_' + listaRotulos[ii].colorAplicacion + '_' + listaRotulos[ii].categoriaLub + '_' + listaRotulos[ii].colorGrado + '_' + listaRotulos[ii].tipoGrado + '_' + listaRotulos[ii].colorTexto
            
            if(listaRotulos[ii].isoGrasaColor){
              descrRotulo += '_' + listaRotulos[ii].isoGrasaColor
            }
            if(listaRotulos[ii].isoGrasaTexto){
              descrRotulo += '_' + listaRotulos[ii].isoGrasaTexto
            }
            if(listaRotulos[ii].apiSAE){
              descrRotulo += '_' + listaRotulos[ii].apiSAE
            }
            let  isoGrasaColor = listaRotulos[ii].isoGrasaColor?listaRotulos[ii].isoGrasaColor:''
            let  isoGrasaTexto = listaRotulos[ii].isoGrasaTexto?listaRotulos[ii].isoGrasaTexto:''
            let  colorTexto = listaRotulos[ii].colorTexto?listaRotulos[ii].colorTexto:''
            let  apiSAE = listaRotulos[ii].apiSAE?listaRotulos[ii].apiSAE:''
            const argsAdd = {
              descrRotulo: descrRotulo,
              descrFrecuencia: listaRotulos[ii].descrFrecuencia,
              claseLub: listaRotulos[ii].claseLub,
              colorAplicacion: listaRotulos[ii].colorAplicacion,
              categoriaLub: listaRotulos[ii].categoriaLub,
              colorGrado: listaRotulos[ii].colorGrado,
              tipoGrado: listaRotulos[ii].tipoGrado,
              isoGrasaColor: isoGrasaColor,
              isoGrasaTexto: isoGrasaTexto,
              colorTexto: colorTexto,
              apiSAE: apiSAE,
              archRotulo: data,
              fechaCreate: fechaHoraHoy,
            }
            if(descrRotulo==='Mensual_Mineral_#154308_H2_#ffffff_NLGI_NEGRO_#000000_BLANCO'){
              console.log(argsAdd) 
            }

            let response = await this.props.createRotulo({
              variables: argsAdd
            });
            const {errors, success} = response.data.createRotulo;
            // console.log("updState", ii)
            if(ii===listaRotulos.length-1){
              this.setState({listRot})
              this.setState({verRotulo: false})

              alert("!! Proceso finalizado !! => rótulos generados")
              this.setState({permiteBtn1: true, open: false, confirmaAct: false})
            }
          }
        
          let svg = svgrotulo
          let svgData = new XMLSerializer().serializeToString( svg );
          let canvas = document.createElement( "canvas" );
          canvas.setAttribute( "height", 200 );
          canvas.setAttribute( "width", 400 );

          let ctx = canvas.getContext( "2d" );
          let img = document.createElement( "img" );
          img.setAttribute( "src", "data:image/svg+xml;base64," + btoa( svgData ) );
          // let editPlantaEstructura = await this.props.editPlantaEstructura
          img.onload = function() {
            // console.log("onload", ii)
            ctx.drawImage( img, 0, 0 );

            // Now is done
            let data=canvas.toDataURL( "image/png" )
            updState(data, ii, svgrotulo)

          }
        }
        document.body.style.cursor = 'default'
      }

  }


  handleQuestionUpdDel = async (ev, btn, opcion) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.list!==prevProps.list){
      this.setState({idListaP: [], listRot: this.props.list})
    }
  }

  render(){
    const {listRot, idListaP, verRotulo, permiteBtn1, confirmaAct, open} = this.state;
    let mensaje1 = "GENERAR ROTULOS"
    let imgIcon1 = "images/archivo_32.png"
    let mensaje2 = "GENERAR PDF RESUMEN"
    let imgIcon2 = "images/archivo_32.png"
  // console.log(idListaP)
  // console.log(idListaP.archRotulo)
  //Traer autorizaciones
  // const a0101 = autorizacUA.findIndex( autorizac => autorizac === "0101" );
  // const a010101 = autorizacUA.findIndex( autorizac => autorizac === "010101" );
  
  // let list = list
  // let list1 = list1
// console.log(listRot)




console.log(this.props.listR)

  let list = []
  if(listRot){
    list = listRot
    for(let i=0; i<listRot.length; i++){
      list[i].idPlanta = i
    }
  }

  let listaRotulos = []
  if(this.props.allPlantaRtesRot.allPlantaRtes){listaRotulos = this.props.allPlantaRtesRot.allPlantaRtes}
  let listR = []
  if(this.props.listR){listR = this.props.listR}
  return (
    <div>
      <List selection>
        {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
        <TitDer list={this.props.list} textBoton1="Generar rótulos" btnNuevo={"NO"} styles={this.props.styles}/>

        {/* <div> */}
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct
            ?permiteBtn1
              ?(ev)=>this.handleSubmit(ev, listR, listaRotulos)
              :()=>{}
            :()=>{}}         
          > 

            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '30%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={this.props.list1}
                      handleChange={this.props.handleChange} />
                  </Form.Field>
                </div>
                {listR.length>0 &&
                  <div className="column" style={{width: '35%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1", "rotulo")}/>
                  </div>
                }
                {list.length>0 &&
                  <div className="column" style={{width: '35%', paddingTop: '0.3em'}}>
                    <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handlePDF(ev, list, this.props.args)} fluid>
                      Generar PDF Resumen
                    </Button>
                  </div>
                }
              </div>
            </div>
            <div style={{height: '30em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Aplicación/Espesante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Método</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Tarea</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Frecuencia</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Lubricante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>tipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Clase Lub</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Categ Lub</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Grado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Tipo Grado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Api SAE</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Iso-Grasa</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Rótulo</th>
                  </tr>
                </thead>
                <ListaPl list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
              </table>
              <p></p>
            </div>
            <hr></hr>

            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '35%', paddingLeft: '1.2em'}}>
                  {/* {verRotulo &&
                    <svg id='svgrotulo' height='200' width='400'>
                    
                    </svg>
                  } */}

                </div>
                <div className="column" style={{width: '65%', paddingTop: '0.3em'}}>
                  {verRotulo &&
                    <svg id='svgrotulo' height='200' width='400'>
                    
                    </svg>
                  }
                  {!verRotulo &&
                    <div>
                      <img src={idListaP.archRotulo?idListaP.archRotulo:""}></img>
                    </div>
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </List>
    </div>
  )
      }
};

export default compose(
graphql(queries.query.allPlantaRtes, {name:'allPlantaRtesPDF',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
// graphql(queries.query.allPlantaRtes, {name:'allPlantaRtesGenRot',
//   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
graphql(queries.query.allPlantaRtes, {name:'allPlantaRtesRot',
    options: (props) => {return {variables: {tipoqry: `[{"$unwind": "$secciones"}, 
    {"$unwind": "$secciones.equipos"}, 
    {"$unwind": "$secciones.equipos.componentes"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"}, 
    {$project: {_id: 1, categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub', 
    claseLub: '$secciones.equipos.componentes.mecanismos.claseLub', 
    colorAplicacion: '$secciones.equipos.componentes.mecanismos.colorAplicacion', 
    colorGrado: '$secciones.equipos.componentes.mecanismos.colorGrado', 
    tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado', 
    descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado', 
    isoGrasaColor: '$secciones.equipos.componentes.mecanismos.isoGrasaColor', 
    isoGrasaTexto: '$secciones.equipos.componentes.mecanismos.isoGrasaTexto', 
    colorTexto: '$secciones.equipos.componentes.mecanismos.colorTexto', 
    apiSAE: '$secciones.equipos.componentes.mecanismos.apiSAE',
    isoGrasa: '$secciones.equipos.componentes.mecanismos.isoGrasa',
    descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia'}}, 
    {$group: {_id: {categoriaLub: '$categoriaLub', claseLub: '$claseLub', colorAplicacion: '$colorAplicacion', 
    colorGrado: '$colorGrado', tipoGrado: '$tipoGrado', descrGrado: '$descrGrado', isoGrasaColor: '$isoGrasaColor', isoGrasaTexto: '$isoGrasaTexto', 
    colorTexto: '$colorTexto', apiSAE: '$apiSAE', isoGrasa: '$isoGrasa', descrFrecuencia: '$descrFrecuencia'}}},
    {$project: {_id: 0, descrFrecuencia: '$_id.descrFrecuencia', claseLub: '$_id.claseLub', 
    categoriaLub: '$_id.categoriaLub', tipoGrado: '$_id.tipoGrado', descrGrado: '$_id.descrGrado', colorGrado: '$_id.colorGrado', 
    colorAplicacion: '$_id.colorAplicacion', isoGrasaColor: '$_id.isoGrasaColor', 
    isoGrasaTexto: '$_id.isoGrasaTexto', colorTexto: '$_id.colorTexto', apiSAE: '$_id.apiSAE', isoGrasa: '$_id.isoGrasa'}},
    {$sort: {descrFrecuencia: 1, claseLub: 1, categoriaLub: 1, tipoGrado: 1, descrGrado: 1, colorGrado: 1, colorAplicacion: 1}}
    ]`}}}}),

  graphql(queries.mutation.createRotulo, {name:'createRotulo'}),
  graphql(queries.mutation.deleteRotulo, {name:'deleteRotulo'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),

)(ConfGenRot2)
